{
    "ChartprovideroptionsHighcharts": "High Charts",
    "ChartprovideroptionsAmcharts": "AM Charts",
    "NAME": "ChartProviderOptions"
}